import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "P3K";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const P3KlistPeriod = "Kepegawaian/PengangkatanP3K/listPeriod/";
export const P3KdetailPeriod = "Kepegawaian/PengangkatanP3K/detailPeriod/";

export const P3KlistCP3K = "Kepegawaian/PengangkatanP3K/listCP3K/";
export const P3KdetailCP3K = "Kepegawaian/PengangkatanP3K/detailCP3K/";
export const P3KdetailP3K = "Kepegawaian/PengangkatanP3K/detailP3K/";
export const P3KprocessP3K = "Kepegawaian/PengangkatanP3K/processP3K/";
export const P3KuploadSKP3K = "Kepegawaian/PengangkatanP3K/uploadSKP3K/";

export const P3KDownloadDraftSK =
  "Kepegawaian/PengangkatanP3K/downloadDraftSK/";

export const masterRank = "Kepegawaian/Rank/list/";
export const masterRankPppk = "Master/List/rankPppk/";
export const masterDocumentType = "Kepegawaian/DocumentType/list/";

export const masterSignatoryOfficial = "Kepegawaian/SignatoryOfficial/list/";
export const p3kDownloadSPMT = "Kepegawaian/PengangkatanP3K/downloadSPMT/";
export const p3kDownloadContract = "Kepegawaian/PengangkatanP3K/downloadDraftContract/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
